/**
 * Shared gallery utility functions.
 */

/** Returns true when the item is a single photo (not a before/after pair) */
export const isSinglePhoto = (item) => item.type === 'single' || (!item.afterImage && item.beforeImage);

